<template>
<v-form ref="f" lazy-validation v-model="valid">
	<v-container v-if="hotels.length">
		<v-row >
			<v-col class="pt-6 mt-1 pb-0" cols="12" sm="6" >
				<span class="headline">Количество обедов за месяц</span>
			</v-col>
			<v-col class="pb-0" cols="12" sm="6" >
				<a-hotel-select v-model="hotelCode"
						  	 :hotels="hotels"
						  	 :loading="hotelLoading"
						  	 @change="getValues">
				</a-hotel-select>
			</v-col>
		</v-row>
		<v-row >
			<v-col class="pt-0" cols="4" sm="3" >
			</v-col>
			<v-col cols="4" sm="2" class="text-center">
				<span class="subtitle-1">{{ lastMonthFormat }}</span>
			</v-col>
			<v-col cols="4" sm="2" class="text-center">
				<span class="subtitle-1">{{ monthFormat }}</span>
			</v-col>
		</v-row>
		<v-row v-for="(line, key) in form" :key="key">
			<v-col class="py-2" cols="4" sm="3" >
				<v-tooltip right max-width="500" v-if="line.tooltip">
					<template v-slot:activator="{ on }">
						<span class="subtitle-1" v-on="on">{{ line.name }} </span><span class="red--text">*</span>
					</template>
					<span>{{ line.tooltip }}</span>
				</v-tooltip>
				<span class="subtitle-1" v-else>{{ line.name }}</span>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="line.meals.value[0]"
							 :loading="valuesLoading"
							 class="my-0 py-0"
							 digits=0
							 readonly>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="line.meals.value[1]"
							 :loading="valuesLoading"
							 class="my-0 py-0"
							 @input.native="dataChanged = true"
							 digits=0>
				</a-number-field>
			</v-col>
		</v-row>
		<v-row >
			<v-col class="py-4" cols="4" sm="3" >
				<span class="subtitle-1">Итого</span>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total[0]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total[1]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
		</v-row>

		<v-row >
			<v-col class="pb-0 pt-0" cols="12" >
				<v-btn color="primary"
					   class="ml-0"
					   :disabled="!dataChanged"
					   @click="validate">
					Сохранить
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
	<v-container v-else>
		<v-row>
			<v-col>
				<p class="subtitle-1">
					Нет доступных P&L отчетов
				</p>
			</v-col>
		</v-row>
	</v-container>
	<v-dialog	v-model="dialogConfirm.show"
			  	persistent
  			  	max-width="600">
		<v-card>
	  		<v-card-title class="headline">
				Подтверждение
			</v-card-title>
	        <v-card-text>

				<v-row>
					<v-col cols="12">
						<span class="text--primary" v-html="dialogConfirm.html"></span>
					</v-col>
					<v-col cols="12" class="mb-4">
						<span class="text--primary">Вы уверены, что ввели коректные данные?</span>
					</v-col>
				</v-row>

				<v-btn class="mr-2" color="primary" @click="send">
					Да
				</v-btn>
				<v-btn class="mx-2" color="secondary" @click="dialogConfirm.show = false">
					Назад
				</v-btn>
	        </v-card-text>
      	</v-card>
	</v-dialog>
</v-form>
</template>

<script>
	import _ from 'lodash'
	import aNumberField from '../../base/ANumberField.vue'
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import {api} from '../../../lib/api'
	import {getMonthName, toNum, toStr} from '../../../js/common.js'

	export default {
		components: {
			aNumberField,
			aHotelSelect
		},
		data: () => ({
			valid: false,
			dataChanged: false,
			hotelCode: '',
			form: {
				rm: {
					name: 'Номерной фонд',
					meals: {
						code: 1901,
						value: ['', '']
					},
				},
				fb: {
					name: 'Служба питания',
					meals: {
						code: 1902,
						value: ['', '']
					},
				},
				ws: {
					name: 'Фитнес и спа',
					meals: {
						code: 1903,
						value: ['', '']
					}
				},
				// rs: {
				// 	name: 'Магазин',
				// 	meals: {
				// 		code: 1904,
				// 		value: ['', '']
				// 	},
				ag: {
					name: 'Администрация',
					meals: {
						code: 1905,
						value: ['', '']
					}
				},
				it: {
					name: 'IT системы',
					meals: {
						code: 1906,
						value: ['', '']
					}
				},
				sm: {
					name: 'Продажи и маркетинг',
					meals: {
						code: 1907,
						value: ['', '']
					}
				},
				pom: {
					name: 'Инженерная служба',
					meals: {
						code: 1908,
						value: ['', '']
					}
				},
				hl: {
					name: 'Прачечная',
					meals: {
						code: 1909,
						value: ['', '']
					}
				},
				sd: {
					name: 'Служебная столовая',
					tooltip: 'Эта строка подразумевает количество обедов персонала служебной столовой',
					meals: {
						code: 1910,
						value: ['', '']
					}
				},

			},
			dc: 50,
			hotels: null,
			valuesLoading: false,
			hotelLoading: false,
			dialogConfirm: {
				show: false,
				html: ''
			}
		}),
		computed: {
			total() {
				let m = [0, 0]
				for (let line in this.form) {
					m[0] += toNum(this.form[line].meals.value[0])
					m[1] += toNum(this.form[line].meals.value[1])
				}
				m[0] = toStr(m[0], 0)
				m[1] = toStr(m[1], 0)

				return m
			},
			selectedHotel() {
				let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
				return this.hotels[index]
			},
			month() {
				if (this.selectedHotel && this.selectedHotel.month) return this.selectedHotel.month
				else return undefined
			},
			monthFormat() {
				if (this.month) return getMonthName(this.month.substr(5, 2), 'Ul')
				else return undefined
			},
			lastMonthFormat() {
				if (!this.month) return undefined
				let d = this.month.substr(5, 2) - 1
				if (d == 0) d = 12
				return getMonthName(d, 'Ul')
			}
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
			// this.hotelCode = 'TEST'

			this.apiFirstCall()
		},
		methods: {
			validate() {
				if (!this.$refs.f.validate()) return

				let notices = [];

				for (let line in this.form) {
					let m1 = toNum(this.form[line].meals.value[1])
					let m0 = toNum(this.form[line].meals.value[0])

					if (m0 > 0 && m1 == 0) {
						notices.push('Вы не ввели обеды по отделу ' + this.form[line].name.toLowerCase() + ', хотя в прошлом месяце вводили.')
					}
				}

				if (notices.length) {
					this.dialogConfirm.show = true
					this.dialogConfirm.html = '<p>' + notices.join('</p><p>') + '</p>'
				}
				else {
					this.send()
				}
			},
			send() {
				this.dialogConfirm.show = false
				this.$store.dispatch('dialogLoadingStart')
				api.post('pl/set_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
					readyDept: 'sd'
				})
				.then(response => {


					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')
					this.dataChanged = false

				}, error => {})
			},
			apiFirstCall() {
				this.hotelLoading = true
				api.post('pl/get_pending_report_month', {
					hotels: this.hotels
				})
				.then(response => {
					this.hotelLoading = false

					this.hotels = response.data.hotels
					this.hotels = this.hotels.filter(hotel => !!hotel.month)
					if (this.hotels.length == 0) return
					this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
					// this.hotelCode = 'TEST'
					this.getValues()

				}, error => {})
			},
			getValues(hotelCode) {
				this.valuesLoading = true

				// if (!hotelCode) hotelCode = this.hotelCode
				// let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(hotelCode)
				// let selectedHotel = this.hotels[index]
				// let month = selectedHotel.month

				api.post('pl/get_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
				})
				.then(response => {
					this.valuesLoading = false

					for (let line in this.form) {
						this.form[line].meals.value = response.data.form[line].meals.value
					}
					this.$refs.f.resetValidation()
					this.dataChanged = false

				}, error => {})
			},
			trimmedForm() {
				let newForm = _.cloneDeep(this.form)

				for (let line in newForm) {
					for (let prop in newForm[line]) {
						if (prop != 'meals') {
							delete newForm[line][prop]
						}
					}
				}

				return newForm
			}
		}
	}
</script>
